'use client'
import { ReportModule } from '@repo/hmrc-itsa/ReportModule'

const ItsaMtdReport = () => {
  return <ReportModule />
}

export default ItsaMtdReport
